import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Contact from '../../../models/Contact';
import { ImpersonateActions } from './ImpersonateActions';
import { ImpersonateQrPanel } from './ImpersonateQrPanel';
import { useLogCaptureAvailable } from '../useLogCaptureAvailable';
import { handoffUrl, useImpersonateHandoff } from './useImpersonateHandoff';

interface ImpersonateDialogProps {
  open: boolean;
  contact: Contact | null;
  onClose: () => void;
  onError: (message: string) => void;
}

export function ImpersonateDialog({ open, contact, onClose, onError }: ImpersonateDialogProps) {
  const {
    isMobile,
    busy,
    handoff,
    secondsLeft,
    expired,
    captureLogs,
    setCaptureLogs,
    openInBrowser,
    openInApp,
  } = useImpersonateHandoff(contact, open, onClose, onError);
  const captureLogsAvailable = useLogCaptureAvailable();

  const name = contact ? `${contact.firstName} ${contact.lastName}` : '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Impersonate {name}</DialogTitle>
      <DialogContent>
        {handoff == null ? (
          <ImpersonateActions
            isMobile={isMobile}
            busy={busy}
            captureLogsAvailable={captureLogsAvailable}
            captureLogs={captureLogs && captureLogsAvailable}
            onCaptureLogsChange={setCaptureLogs}
            onOpenInApp={openInApp}
            onOpenInBrowser={openInBrowser}
          />
        ) : (
          <ImpersonateQrPanel
            url={handoffUrl(handoff.token)}
            secondsLeft={secondsLeft}
            expired={expired}
            busy={busy === 'app'}
            onRegenerate={openInApp}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ImpersonateDialog;
